export const HJID = +process.env.NEXT_PUBLIC_HJID!;
export const HJSV = +process.env.NEXT_PUBLIC_HJSV!;
